var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('bottom-sheet', {
    attrs: {
      "title": "프로그램 미리보기",
      "fullscreen": "",
      "persistent": "",
      "width": "1210",
      "maxWidth": "100%"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(bind) {
        return [_vm._t("activator", null, null, bind)];
      }
    }], null, true),
    model: {
      value: _vm.shows,
      callback: function callback($$v) {
        _vm.shows = $$v;
      },
      expression: "shows"
    }
  }, [_c('v-layout', {
    staticClass: "bottom-sheet__contents h-100",
    attrs: {
      "column": "",
      "justify-center": ""
    }
  }, [_c('v-sheet', {
    staticClass: "scroll-primary pr-10",
    staticStyle: {
      "flex": "0 1 auto",
      "overflow-y": "auto",
      "overflow-x": "hidden"
    }
  }, [_c('expo-program-view', _vm._b({
    attrs: {
      "isPreview": ""
    }
  }, 'expo-program-view', {
    program: _vm.program
  }, false))], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }